import Helper from '@ember/component/helper';
import { getOwner } from '@ember/owner';
import type SessionService from 'walden-trace-app/services/session';

export default class isGuestModeHelper extends Helper {
  compute() {
    const sessionService = getOwner(this)?.lookup('service:session') as SessionService;
    return sessionService.isGuest;
  }
}
